import { render } from "./Moodboard.vue?vue&type=template&id=045b0f59&scoped=true"
import script from "./Moodboard.vue?vue&type=script&lang=js"
export * from "./Moodboard.vue?vue&type=script&lang=js"

import "./Moodboard.vue?vue&type=style&index=0&id=045b0f59&lang=scss&scoped=true"
import "./Moodboard.vue?vue&type=style&index=1&id=045b0f59&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045b0f59"]])

export default __exports__